import { useCallback } from "react";
import { useLocation } from "react-router";
import { useDashboardContext } from "../dashboard/Dashboard.shared";
import { useScrollPositionRestoration } from "../scrollRestoration/useScrollPositionRestoration";

export const useTabbedListScrollRestoration = (
  selectedTab: number | string,
) => {
  const { getParentScrollPosition, isTwoPanel, setParentScrollPosition } =
    useDashboardContext();
  const location = useLocation();
  const listRoute = location.pathname.split("/").filter(Boolean)[0] ?? "root";
  const getScrollPosition = useCallback(
    () => (isTwoPanel ? getParentScrollPosition() : window.scrollY),
    [getParentScrollPosition, isTwoPanel],
  );
  const restoreScrollPosition = useCallback(
    (scrollTop: number) => {
      if (isTwoPanel) {
        setParentScrollPosition(scrollTop);
        return;
      }

      window.scrollTo({ top: scrollTop });
    },
    [isTwoPanel, setParentScrollPosition],
  );

  return useScrollPositionRestoration({
    // React Router owns window scroll restoration. This hook only restores
    // the independent parent pane used by the desktop split layout.
    enabled: isTwoPanel,
    restorationKey: `tabbed-list:${listRoute}:${selectedTab}`,
    getScrollPosition,
    restoreScrollPosition,
  });
};
